import React from "react";
import MultiSelectDropdown from "../../../dropdown/MultiSelectDropdown";
import Option from "../../../dropdown/multiSelectDropdownOption/MultiSelectOption";
import Validation from "../../../../utils/validation/ValidationText";
import ImageCropperWithUpload from "../../../ImageUpload/UploadImage";
import DropdownSelect from "../../../dropdown/Dropdown";
import TextInput from "../../../UIComponent/TextInput";
import DatePicker from "../../../datePicker/DatePicker";
import moment from "moment";
import Selector from "../../../dropdown/commonDropdown/Selector";
import ButtonLoader from "../../../common/buttonLoader/ButtonLoader";
import ImageUploadTest from "../../../ImageUpload3/ImageUploadTest";

// import ImageCropperWithUpload from "../../../ImageUpload/UploadImage";

function OrganisationProfile(props) {
  return (
    <div>
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
        <div className="grid grid-cols-12 gap-6 w-full ">
          <div className="xl:col-span-12 lg:col-span-12 col-span-12">
            <div className="grid grid-cols-12 gap-6 w-full ">
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Issued Capital

                    </h2>
                    <div className="flex items-center">
                      <div className="w-full outline-none appearance-none">
                        <TextInput
                          placeholder=""
                          type="text"
                          name="issuedCapital"
                          value={props.organizationProfile.issuedCapital}
                          identity="OrganizationProfile"
                          handleChange={props.handleChange}
                        // onBlur={(e) =>
                        //   props.validate("paidUpCapital", props.organizationProfile)
                        // }
                        />
                      </div>
                    </div>
                    {/* <Validation
                      error={props.validState.error.IssuedCapital}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Paid-Up Capital

                    </h2>
                    <div className="flex items-center">
                      <div className="w-full outline-none appearance-none">
                        <TextInput
                          placeholder=""
                          type="text"
                          name="paidUpCapital"
                          value={props.organizationProfile.paidUpCapital}
                          identity="OrganizationProfile"
                          handleChange={props.handleChange}
                        // onBlur={(e) =>
                        //   props.validate("paidUpCapital", props.organizationProfile)
                        // }
                        />
                      </div>
                    </div>
                    {/* <Validation
                      error={props.validState.error.paidUpCapital}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Employment Size

                    </h2>
                    <DropdownSelect
                      drpIdentity={"CompanyEmploymentSize"}
                      optionArray={props.companyEmploymentSize}
                      setFilterParameters={props.setFilterParameters}
                      value={props.organizationProfile.employmentSizeID}
                    // onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                    />
                    {/* <Validation
                      error={props.validState.error.staffStrength}
                    /> */}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Telephone

                    </h2>

                    <div className="flex items-center country-code-select">

                      <DropdownSelect
                        drpIdentity={"countriesDailingCode"}
                        optionArray={props.countriesDailingCode}
                        setFilterParameters={props.setFilterParameters}
                        value={props.organizationProfile.telephoneCountryId}
                      // onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                      />
                      {/* <Validation
                      error={props.validState.error.staffStrength}
                    /> */}
                      <TextInput
                        placeholder=""
                        type="text"
                        name="telephone"
                        value={
                          props.organizationProfile.telephone
                        }
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "telephone",
                      //     props.organizationProfile
                      //   )
                      // }
                      />
                    </div>
                    {/* <Validation
                      error={props.validState.error.telephone}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6 ">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Email (company admin email)

                    </h2>
                    <div className="flex items-center">
                      <TextInput
                        placeholder=""
                        type="email"
                        name="companyAdminEmail"
                        value={props.organizationProfile.companyAdminEmail}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "companyAdminEmail",
                      //     props.organizationProfile
                      //   )
                      // }
                      />
                    </div>
                    {/* <Validation error={props.validState.error.companyAdminEmail} /> */}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Incorporation Country

                    </h2>
                    <Selector
                      drpIdentity="incorporationCountry"
                      options={props.countriesWithPresence}
                      // isMulti
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      // components={{ Option }}
                      onChange={props.handleChangeMultiDropdown}
                      allowSelectAll={false}
                      value={props.countriesWithPresence.find(
                        (country) =>
                          country.value === props.organizationProfile.incorporationCountryId
                      )}
                    />
                    {/* <Validation error={props.validState.error.countryId} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-12 lg:col-span-12 col-span-12">
            <div className="grid grid-cols-12 gap-6 w-full ">
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Fax

                    </h2>

                    <div className="flex items-center country-code-select">
                      <DropdownSelect
                        drpIdentity={"faxCountryCode"}
                        optionArray={props.countriesDailingCode}
                        setFilterParameters={props.setFilterParameters}
                        value={props.organizationProfile.faxCountryId}
                      // onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                      />
                      {/* <Validation
                      error={props.validState.error.staffStrength}
                    /> */}
                      <TextInput
                        placeholder=""
                        type="text"
                        name="fax"
                        value={
                          props.organizationProfile.fax
                        }
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "telephone",
                      //     props.organizationProfile
                      //   )
                      // }
                      />
                    </div>
                    {/* <Validation
                      error={props.validState.error.telephone}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">

                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Shareholders' Equities

                    </h2>

                    <div className="flex items-center ">
                      <TextInput
                        placeholder=""
                        type="text"
                        name="shareholdersEquities"
                        value={
                          props.organizationProfile.shareholdersEquities
                        }
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "telephone",
                      //     props.organizationProfile
                      //   )
                      // }
                      />
                    </div>
                    {/* <Validation
                      error={props.validState.error.telephone}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">

                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Real Estate and Related Activities
                    </h2>


                    <div className="flex items-center multiselect-input">
                      {(() => {
                        const optionsList = (
                          props.organizationProfile.membershipTypeId === 1
                            ? props.RealEstateAndRelatedActivitiesForOrdinary
                            : props.RealEstateAndRelatedActivitiesForAssociate
                        ).map(item => ({
                          label: item.name,
                          value: item.id
                        }));

                        const selectedValues = optionsList.filter(option =>
                          Array.isArray(props.organizationProfile.realEstateActivitiesID) &&
                          props.organizationProfile.realEstateActivitiesID.includes(option.value)
                        );

                        return (
                          <MultiSelectDropdown
                            labelTitle={true}
                            fieldLabel="Real Estate and Related Activities"
                            options={optionsList}
                            value={selectedValues}
                            onChange={(selected) => props.setFilterParameters(selected, "RealEstateActivities")}
                            drpIdentity="RealEstateActivities"
                            allowSelectAll={true}
                          />
                        );
                      })()}
                    </div>


                    {/* <Validation error={props.validState.error.telephone} /> */}
                  </div>


                  {Array.isArray(props.organizationProfile.realEstateActivitiesID) &&
                    (props.organizationProfile.realEstateActivitiesID.includes(8) ||
                      props.organizationProfile.realEstateActivitiesID.includes(12)) && (
                      <div className="col-span-12">
                        <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                          Others (Please specify)
                        </h2>
                        <div className="flex items-center">
                          <TextInput
                            labelTitle={true}
                            name="realEstateSpecification"
                            value={props.organizationProfile.realEstateSpecification}
                            handleChange={props.handleChange}
                            identity="OrganizationProfile"
                          />
                        </div>
                      </div>
                    )}

                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">

                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      What is your company interested in?

                    </h2>

                    <div className="flex items-center">
                      <DropdownSelect
                        drpIdentity={"interestedIn"}
                        optionArray={props.companyInterestedList}
                        setFilterParameters={props.setFilterParameters}
                        value={props.organizationProfile.interestedInId}
                      // onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                      />
                    </div>
                    {/* <Validation
                      error={props.validState.error.telephone}
                    /> */}


                  </div>

                  {(props.organizationProfile.interestedInId === 11) && (
                    <div className="col-span-12">
                      <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                        Others (Please specify)

                      </h2>

                      <div className="flex items-center">

                        <TextInput
                          labelTitle={true}
                          name="companyInterestedSpecification"
                          value={props.organizationProfile.companyInterestedSpecification}
                          handleChange={props.handleChange}
                          identity="OrganizationProfile"
                        />

                      </div>

                    </div>
                  )}
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">

                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      How did you hear about us?

                    </h2>

                    <div className="flex items-center">
                      <DropdownSelect
                        drpIdentity={"getToKnow"}
                        optionArray={props.getToKnowList}
                        setFilterParameters={props.setFilterParameters}
                        value={props.organizationProfile.getToKnowId}
                      // onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                      />
                    </div>
                    {/* <Validation
                      error={props.validState.error.telephone}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">

                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Total Group Asset

                    </h2>

                    <div className="flex items-center">
                      <DropdownSelect
                        drpIdentity={"TotalGroupAssetsType"}
                        optionArray={props.totalGroupAsset}
                        setFilterParameters={props.setFilterParameters}
                        value={props.organizationProfile.totalGroupAssetID}
                      // onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                      />
                    </div>
                    {/* <Validation
                      error={props.validState.error.telephone}
                    /> */}
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">

                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Website

                    </h2>

                    <div className="flex items-center">
                      <div className="w-full outline-none appearance-none">
                        <TextInput
                          placeholder=""
                          type="text"
                          name="website"
                          value={props.organizationProfile.website}
                          identity="OrganizationProfile"
                          handleChange={props.handleChange}
                        // onBlur={(e) =>
                        //   props.validate("paidUpCapital", props.organizationProfile)
                        // }
                        />
                      </div>
                    </div>
                    {/* <Validation
                      error={props.validState.error.telephone}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid-cols-12 gap-6 w-full mt-9">
                  <div className="2xl:col-span-12 lg:col-span-12 col-span-12 ml-auto">
                    {/* ACRA */}
                    <div className="input-sec-texts 2xl:col-span-6 lg:col-span-6 col-span-12">
                      <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                        ACRA Business Profile
                        &nbsp;
                        <span className="font-medium text-[#757575]">
                          (Please Upload in PDF Format Only)
                        </span>
                      </h2>
                      <div className="flex item-center flex-col">
                        <form className="custom-uploader custom-file-upload-btn flex">
                          <div className="btn btn-red border-[#f3f3f3] btn btn-blue cursor-pointer">
                            <label
                              htmlFor={`upload_File`}
                              className="text-uplod block lg:text-[18px] text-[16px] text-[#ffffff]"
                            >
                              Upload PDF File
                            </label>
                            <input
                              className="sr-only"
                              id={`upload_File`}
                              type="file"
                              onChange={(event) => props.onFileChangePDF(event)}
                            />
                          </div>
                        </form>
                        {props.organizationProfile.acraFilePath ? (
                          <div className="mt-5 file-uploaded-txt flex items-center">
                            <img
                              src="/checked-icon.svg"
                              className="w-[25px] mr-3"
                              alt=""
                            />
                            <span className="text-[#757575] big-bullet-points font-bold">
                              {props.organizationProfile.acraFilePath}
                            </span>
                            <button
                              className="2xl:px-7 lg:px-3 2xl:py-2 lg:py-0 w-50 px-7 py-3 text-xl text-[#C00000]"
                              onClick={() =>
                                props.getInvoiceReceiptPdfByBookingId(0, "ACRA")
                              }
                            >
                              <span className="text-xl no-wrap text-[#c00000] font-semibold tracking-normal underline">
                                View ACRA PDF
                              </span>
                            </button>
                            <button
                              className="underline text-[#e74c3c] font-[500] ml-3"
                              onClick={() =>
                                props.deleteFile(
                                  props.organizationProfile.acraFilePath,
                                  "ACRAFile"
                                )
                              }
                            >
                              <img
                                src="/delete-icon.png"
                                className="w-[25px] mr-3"
                                alt=""
                              />
                            </button>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6 w-full mt-9">
                  <div className="2xl:col-span-12 lg:col-span-12 col-span-12">
                    <div className="company-logo-cropper ml-auto mr-auto">
                      <div className="individual-profile-create-cropper">
                        <ImageUploadTest
                          key="Main"
                          height={180}
                          width={400}
                          isCheckValidation={true}
                          MaxFileSize={2097152}
                          MaxFileSizeMessage={"2MB"}
                          onSaveImage={props.saveMainImage}
                          aspactRatio={400 / 180}
                          imageIdentity="CorporateCompanyLogo"
                          intitImage={props.organizationProfile.orgLogoFileName}
                          uploadBtn={"Upload Photo"}
                          dimensionText={"(Dimension: 400px by 180px Maximum Size: 2MB)"}
                        />
                      </div>
                      <div className=" text-center">
                        {/* <Validation
                          error={props.validState.error.orgLogoFileName}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="xl:col-span-12 lg:col-span-12 col-span-12 input-sec-texts">
                  <div className="left-tiitle">
                    <h4 className="small-title 2xl:text-[22px] font-bold text-[#757575] ">
                      Registered Address (Based on ACRA)&nbsp;
                      <span className="text-[#F93549]">*</span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts"></div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Registered Office Address Line 1

                    </h2>
                    <div className="flex items-center">
                      <TextInput
                        placeholder=""
                        type="text"
                        name="registeredOfficeAddressLine1"
                        value={props.organizationProfile.registeredOfficeAddressLine1}
                        maxLength={100}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "registeredStreetName",
                      //     props.organizationProfile
                      //   )
                      // }
                      />
                    </div>
                    {/* <Validation error={props.validState.error.registeredStreetName} /> */}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Registered Office Address Line 3
                    </h2>
                    <div className="flex items-center">
                      <TextInput
                        placeholder=""
                        type="text"
                        name="registeredOfficeAddressLine3"
                        maxLength={100}
                        value={props.organizationProfile.registeredOfficeAddressLine3}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                        // onBlur={(e) =>
                        //   props.validate(
                        //     "registeredPostalCode",
                        //     props.organizationProfile
                        //   )
                        // }
                        autoComplete={"off"}
                      />
                    </div>
                    {/* <Validation error={props.validState.error.registeredPostalCode} /> */}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Registered Address Postal Code

                    </h2>
                    <div className="flex items-center">
                      <TextInput
                        placeholder=""
                        type="text"
                        name="registeredOfficePostalCode"
                        maxLength={100}
                        value={props.organizationProfile.registeredOfficePostalCode}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                        // onBlur={(e) =>
                        //   props.validate(
                        //     "registeredPostalCode",
                        //     props.organizationProfile
                        //   )
                        // }
                        autoComplete={"off"}
                      />
                    </div>
                    {/* <Validation error={props.validState.error.registeredPostalCode} /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Registered Office Address Line 2
                    </h2>
                    <div
                    // className={`flex items-center ${props.organizationProfile.registeredOfficeAddressLine2
                    //   ? "disableVouchercode"
                    //   : ""
                    //   }`}
                    >
                      <TextInput
                        placeholder=""
                        type="text"
                        name="registeredOfficeAddressLine2"
                        value={props.organizationProfile.registeredOfficeAddressLine2}
                        maxLength={100}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "registeredBuildingName",
                      //     props.organizationProfile
                      //   )
                      // }
                      // disabled={
                      //   props.organizationProfile.registeredNoUnitNumber
                      // }
                      />
                    </div>
                    {/* {!props.organizationProfile.registeredNoUnitNumber && (
                      <Validation error={props.validState.error.registeredBuildingName} />
                    )} */}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Registered Office Country

                    </h2>
                    <Selector
                      drpIdentity="registeredCountry"
                      options={props.countriesWithPresence}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={props.handleChangeMultiDropdown}
                      allowSelectAll={false}
                      value={props.countriesWithPresence.find(
                        (country) =>
                          country.value === props.organizationProfile.registeredCountryId
                      )}
                    />
                    {/* <Validation error={props.validState.error.countryId} /> */}
                  </div>
                </div>

              </div>

              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="xl:col-span-12 lg:col-span-12 col-span-12 input-sec-texts">
                  <div className="left-tiitle">
                    <h4 className="small-title 2xl:text-[22px] font-bold text-[#757575] ">
                      Mailing Address
                    </h4>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts"></div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Mailing Address Line 1

                    </h2>
                    <div className="flex items-center">
                      <TextInput
                        placeholder=""
                        type="text"
                        name="mailingAddressLine1"
                        value={props.organizationProfile.mailingAddressLine1}
                        maxLength={100}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "mailingStreetName",
                      //     props.organizationProfile
                      //   )
                      // }
                      />
                    </div>
                    {/* <Validation error={props.validState.error.mailingStreetName} /> */}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Mailing Address Line 3
                    </h2>
                    <div className="flex items-center">
                      <TextInput
                        placeholder=""
                        type="text"
                        name="mailingAddressLine3"
                        maxLength={100}
                        value={props.organizationProfile.mailingAddressLine3}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                        // onBlur={(e) =>
                        //   props.validate(
                        //     "mailingPostalCode",
                        //     props.organizationProfile
                        //   )
                        // }
                     //   autoComplete={"off"}
                      />
                    </div>
                    {/* <Validation error={props.validState.error.mailingPostalCode} /> */}
                  </div>
                </div>

                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Mailing Address Postal Code

                    </h2>
                    <div className="flex items-center">
                      <TextInput
                        placeholder=""
                        type="text"
                        name="mailingAddressPostalCode"
                        maxLength={100}
                        value={props.organizationProfile.mailingAddressPostalCode}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                        // onBlur={(e) =>
                        //   props.validate(
                        //     "registeredPostalCode",
                        //     props.organizationProfile
                        //   )
                        // }
                        autoComplete={"off"}
                      />
                    </div>
                    {/* <Validation error={props.validState.error.registeredPostalCode} /> */}
                  </div>
                </div>

              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Mailing Address Line 2
                    </h2>
                    <div
                    // className={`flex items-center ${props.organizationProfile.mailingAddressLine2
                    //   ? "disableVouchercode"
                    //   : ""
                    //   }`}
                    >
                      <TextInput
                        placeholder=""
                        type="text"
                        name="mailingAddressLine2"
                        value={props.organizationProfile.mailingAddressLine2}
                        maxLength={100}
                        identity="OrganizationProfile"
                        handleChange={props.handleChange}
                      // onBlur={(e) =>
                      //   props.validate(
                      //     "mailingBuildingName",
                      //     props.organizationProfile
                      //   )
                      // }
                      // disabled={props.organizationProfile.mailingAddressLine3}
                      />
                    </div>
                    {/* {!props.organizationProfile.mailingNoUnitNumber && (
                      <Validation error={props.validState.error.mailingBuildingName} />
                    )} */}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-9">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Mailing Address Country

                    </h2>
                    <Selector
                      drpIdentity="mailingCountry"
                      options={props.countriesWithPresence}
                      // isMulti
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      // components={{ Option }}
                      onChange={props.handleChangeMultiDropdown}
                      allowSelectAll={false}
                      value={props.countriesWithPresence.find(
                        (country) =>
                          country.value === props.organizationProfile.mailingAddressCountry
                      )}
                    />
                    {/* {!props.organizationProfile.mailingNoUnitNumber && (
                      <Validation error={props.validState.error.mailingBuildingName} />
                    )} */}
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Updated By
                    </h2>
                    <div className="disabled-input flex items-center">
                      <DropdownSelect
                        disabled={true}
                        drpIdentity={"updatedById"}
                        optionArray={props._By}
                        setFilterParameters={props.setFilterParameters}
                        value={props.organizationProfile.updatedBy}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Last Updated Date
                    </h2>
                    <div className="disabled-input">
                      {props.organizationProfile.updatedAt === "" ||
                        props.organizationProfile.updatedAt === null ||
                        props.organizationProfile.updatedAt ===
                        "1900-01-01T00:00:00" ? (
                        <TextInput
                          disabled={true}
                          placeholder=""
                          type="text"
                          name="linkedIn"
                          value="None"
                          identity="BasicInformation"
                        />
                      ) : (
                        <DatePicker
                          isDisable={true}
                          name="updatedAt"
                          handleChange={props.handleChange}
                          identity="updatedAt"
                          value={moment(
                            props.organizationProfile.updatedAt
                          ).format("yyyy-MM-DD")}
                        />
                      )}
                    </div>
                    {/* <div className="disabled-input flex items-center">
                      <DatePicker
                        name="updatedAt"
                        isDisable={true}
                        handleChange={props.handleChange}
                        identity="OrganizationProfile"
                        value={moment(
                          props.organizationProfile.updatedAt
                        ).format("yyyy-MM-DD")}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Save Button */}
      <div className="grid grid-cols-12 gap-6 pb-10">
        <div className="xl:col-span-12 lg:col-span-12 col-span-12 px-10">
          <div className="flex items-center justify-end">
            {props && props.isOrganizationProfileLoading === true ? (
              <ButtonLoader />
            ) : (
              <button
                className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                onClick={() => props.onSave()}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrganisationProfile;
